//mypreset.ts
import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AfraTheme = definePreset(Aura, {
  semantic: {
    // primary: palette('#007038'),
    primary: palette('#43ab34'),
    icon: palette('#B2BAC2'),
  },
  components: {
    badge: {
      extend: {
        dangerDot: {
          color: 'var(--color-red-700)',
          background: 'var(--color-red-600)',
        },
      },
      colorScheme: {
        light: {
          warn: {
            color: 'var(--color-amber-700)',
            background: 'var(--color-orange-100)',
          },
          success: {
            color: 'var(--color-green-700)',
            background: 'var(--color-green-100)',
          },
          danger: {
            color: 'var(--color-red-700)',
            background: 'var(--color-red-100)',
          },
          info: {
            color: 'var(--color-sky-700)',
            background: 'var(--color-blue-100)',
          },
        },
      },
    },
  },
});

export default AfraTheme;
